import React, { useState } from 'react';
import { Box, Paper, Typography, Collapse, Button, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchResultItem from './SearchResultItem';

/**
 * Treffer, die das gefilterte Board nicht zeigen kann.
 *
 * Das Board ist auf ein Projekt beschränkt und blendet abgeschlossene Tickets
 * älterer Wochen aus. Ohne dieses Panel würde eine Suche nach einem alten
 * Ticket „keine Treffer" suggerieren, obwohl es existiert – der einzige Fehler,
 * den eine Suche nicht machen darf.
 */
function SearchResultsPanel({ offBoardResults, terms, onOpen, onBoardCount }) {
  const [open, setOpen] = useState(true);
  const count = offBoardResults.length;

  if (count === 0) {
    return onBoardCount === 0 ? (
      <Paper variant="outlined" sx={{ p: 2, mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Keine Treffer – auch nicht in abgeschlossenen oder archivierten Tickets.
        </Typography>
      </Paper>
    ) : null;
  }

  const reasons = [];
  const done = offBoardResults.filter((r) => r.is_done_status && r.is_active).length;
  const archived = offBoardResults.filter((r) => !r.is_active).length;
  const other = count - done - archived;
  if (done) reasons.push(`${done} abgeschlossen`);
  if (archived) reasons.push(`${archived} archiviert`);
  if (other) reasons.push(`${other} außerhalb dieser Ansicht`);

  return (
    <Paper variant="outlined" sx={{ mt: 2, overflow: 'hidden' }}>
      <Button
        fullWidth
        onClick={() => setOpen((v) => !v)}
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{ justifyContent: 'space-between', px: 2, py: 1.25, textTransform: 'none', color: 'text.primary' }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {count} weitere{count === 1 ? 'r' : ''} Treffer außerhalb des Boards
          {reasons.length > 0 && (
            <Typography component="span" variant="body2" color="text.secondary" sx={{ fontWeight: 400 }}>
              {'  ('}{reasons.join(', ')}{')'}
            </Typography>
          )}
        </Typography>
      </Button>

      <Divider />

      <Collapse in={open}>
        <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, maxHeight: 420, overflowY: 'auto' }}>
          {offBoardResults.map((result) => (
            <SearchResultItem
              key={result.task.id}
              result={result}
              terms={terms}
              onOpen={onOpen}
              showProject
            />
          ))}
        </Box>
      </Collapse>
    </Paper>
  );
}

export default SearchResultsPanel;
